"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerSearchControlsContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ManagerSearchControlsContainer = styled_components_1.default.div `
  padding: 30px 0;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
`;
//# sourceMappingURL=search-controls-container.js.map